import React from 'react';
import {
  Type,
  Hash,
  Calendar,
  ChevronDown,
  Check,
  CheckSquare,
  Link,
  Mail,
  Phone,
  IndianRupee,
  AlignLeft
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { CustomFieldType, FIELD_TYPE_CONFIGS } from '@/types/customField';

interface FieldTypeSelectorProps {
  selectedType: CustomFieldType | null;
  onChange: (type: CustomFieldType) => void;
  disabled?: boolean;
}

// Icon mapping
const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  Type,
  Hash,
  Calendar,
  ChevronDown,
  Check,
  CheckSquare,
  Link,
  Mail,
  Phone,
  IndianRupee,
  AlignLeft,
};

export const FieldTypeSelector: React.FC<FieldTypeSelectorProps> = ({
  selectedType,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
      {FIELD_TYPE_CONFIGS.map((config) => {
        const IconComponent = iconMap[config.icon] || Type;
        const isSelected = selectedType === config.type;

        return (
          <button
            key={config.type}
            type="button"
            onClick={() => onChange(config.type)}
            disabled={disabled}
            className={cn(
              'flex flex-col items-center gap-2 p-3 rounded-lg border-2 transition-all text-center',
              isSelected
                ? 'border-blue-500 bg-blue-50'
                : 'border-gray-200 hover:border-gray-300 bg-white',
              disabled && 'opacity-50 cursor-not-allowed'
            )}
          >
            <div className={cn(
              'w-10 h-10 rounded-lg flex items-center justify-center',
              isSelected ? 'bg-blue-100' : 'bg-gray-100'
            )}>
              <IconComponent className={cn(
                'w-5 h-5',
                isSelected ? 'text-blue-600' : 'text-gray-500'
              )} />
            </div>
            <div>
              <div className={cn(
                'text-sm font-medium',
                isSelected ? 'text-blue-700' : 'text-gray-700'
              )}>
                {config.label}
              </div>
              <div className="text-xs text-gray-500 mt-0.5 line-clamp-1">
                {config.description}
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};
